"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishAuthoriserFlowReason = void 0;
var FinishAuthoriserFlowReason;
(function (FinishAuthoriserFlowReason) {
    FinishAuthoriserFlowReason["SUCCESS"] = "SUCCESS";
    FinishAuthoriserFlowReason["ERROR"] = "ERROR";
    FinishAuthoriserFlowReason["CANCEL"] = "CANCEL";
    FinishAuthoriserFlowReason["UNMOUNT"] = "UNMOUNT";
})(FinishAuthoriserFlowReason || (exports.FinishAuthoriserFlowReason = FinishAuthoriserFlowReason = {}));
//# sourceMappingURL=events.js.map